import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const SvgHotel = ({ title, titleId, ...props }, ref)=>/*#__PURE__*/ jsxs("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        role: "img",
        ref: ref,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.87012 2.16748C6.55828 2.16748 6.30762 2.41814 6.30762 2.72998V21.5474H8.60938V17.895C8.60938 17.2341 9.14874 16.6951 9.80957 16.6948H14.1895C14.8505 16.6948 15.3896 17.234 15.3896 17.895V21.5474H17.6924V2.72998C17.6924 2.41818 17.4417 2.16754 17.1299 2.16748H6.87012Z",
                fill: "var(--horizon-icon-shade-4, #D2E6FF)"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.6875 11.5503C1.37566 11.5503 1.125 11.801 1.125 12.1128V20.9849C1.1252 21.2965 1.37578 21.5474 1.6875 21.5474H5.18262V11.5503H1.6875ZM18.8174 21.5474H22.3125C22.6242 21.5474 22.8748 21.2965 22.875 20.9849V12.1128C22.875 11.801 22.6243 11.5503 22.3125 11.5503H18.8174V21.5474Z",
                fill: "var(--horizon-icon-shade-1, #fff)"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M9.50977 17.895C9.50977 17.7312 9.64579 17.5955 9.80957 17.5952H11.5498V21.5474H9.50977V17.895Z",
                fill: "var(--horizon-icon-shade-1, #fff)"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M14.4893 21.5474H12.4502V17.5952H14.1895C14.3534 17.5952 14.4893 17.731 14.4893 17.895V21.5474Z",
                fill: "var(--horizon-icon-shade-1, #fff)"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M3.49512 17.5571C3.81007 17.5572 4.06543 17.8125 4.06543 18.1274V18.7954C4.06517 19.1102 3.80991 19.3647 3.49512 19.3647H2.8125C2.49766 19.3647 2.24244 19.1102 2.24219 18.7954V18.1274C2.24219 17.8124 2.4975 17.5571 2.8125 17.5571H3.49512Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M3.49512 13.9351C3.8099 13.9351 4.06517 14.1897 4.06543 14.5044V15.1724C4.06543 15.4873 3.81007 15.7426 3.49512 15.7427H2.8125C2.4975 15.7427 2.24219 15.4874 2.24219 15.1724V14.5044C2.24245 14.1896 2.49766 13.9351 2.8125 13.9351H3.49512Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M9.80273 11.7671C10.1176 11.7672 10.372 12.0225 10.3721 12.3374V13.0054C10.3718 13.3201 10.1175 13.5746 9.80273 13.5747H9.12012C8.80525 13.5747 8.55003 13.3202 8.5498 13.0054V12.3374C8.54983 12.0224 8.80514 11.7671 9.12012 11.7671H9.80273Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M14.8799 11.7671C15.1949 11.7671 15.4502 12.0224 15.4502 12.3374V13.0054C15.45 13.3202 15.1947 13.5747 14.8799 13.5747H14.1973C13.8825 13.5746 13.6282 13.3201 13.6279 13.0054V12.3374C13.628 12.0225 13.8824 11.7672 14.1973 11.7671H14.8799Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M9.80273 8.42236C10.1176 8.42249 10.3721 8.67776 10.3721 8.99268V9.65967C10.3721 9.97459 10.1176 10.2299 9.80273 10.23H9.12012C8.80512 10.23 8.5498 9.97467 8.5498 9.65967V8.99268C8.5498 8.67768 8.80512 8.42236 9.12012 8.42236H9.80273Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M14.8799 8.42236C15.1949 8.42236 15.4502 8.67768 15.4502 8.99268V9.65967C15.4502 9.97467 15.1949 10.23 14.8799 10.23H14.1973C13.8824 10.2299 13.6279 9.97459 13.6279 9.65967V8.99268C13.6279 8.67775 13.8824 8.42249 14.1973 8.42236H14.8799Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M9.80273 5.08447C10.1176 5.0846 10.372 5.33989 10.3721 5.65479V6.32275C10.3718 6.63748 10.1175 6.89196 9.80273 6.89209H9.12012C8.80526 6.89209 8.55003 6.63756 8.5498 6.32275V5.65479C8.54983 5.33981 8.80513 5.08447 9.12012 5.08447H9.80273Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M14.8799 5.08447C15.1949 5.08447 15.4502 5.33981 15.4502 5.65479V6.32275C15.45 6.63756 15.1947 6.89209 14.8799 6.89209H14.1973C13.8825 6.89196 13.6282 6.63749 13.6279 6.32275V5.65479C13.628 5.33989 13.8824 5.0846 14.1973 5.08447H14.8799Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M21.1875 17.4526C21.5024 17.4526 21.7576 17.7071 21.7578 18.022V18.6899C21.7578 19.0049 21.5025 19.2603 21.1875 19.2603H20.5049C20.19 19.2602 19.9346 19.0049 19.9346 18.6899V18.022C19.9348 17.7072 20.1901 17.4527 20.5049 17.4526H21.1875Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M21.1875 13.8374C21.5025 13.8374 21.7578 14.0927 21.7578 14.4077V15.0747C21.7578 15.3897 21.5025 15.645 21.1875 15.645H20.5049C20.1899 15.645 19.9346 15.3897 19.9346 15.0747V14.4077C19.9346 14.0928 20.1899 13.8375 20.5049 13.8374H21.1875Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.1299 1.04248C18.063 1.04254 18.8174 1.79686 18.8174 2.72998V10.4253H22.3125C23.2457 10.4253 24 11.1796 24 12.1128V20.9849C23.9998 21.9179 23.2455 22.6724 22.3125 22.6724H1.6875C0.754462 22.6724 0.000197326 21.9179 0 20.9849V12.1128C0 11.1796 0.75434 10.4253 1.6875 10.4253H5.18262V2.72998C5.18262 1.79682 5.93696 1.04248 6.87012 1.04248H17.1299ZM1.6875 11.5503C1.37566 11.5503 1.125 11.801 1.125 12.1128V20.9849C1.1252 21.2965 1.37578 21.5474 1.6875 21.5474H5.18262V11.5503H1.6875ZM6.87012 2.16748C6.55828 2.16748 6.30762 2.41814 6.30762 2.72998V21.5474H8.60938V17.895C8.60938 17.2341 9.14874 16.6951 9.80957 16.6948H14.1895C14.8505 16.6948 15.3896 17.234 15.3896 17.895V21.5474H17.6924V2.72998C17.6924 2.41818 17.4417 2.16754 17.1299 2.16748H6.87012ZM9.80957 17.5952C9.64579 17.5955 9.50977 17.7312 9.50977 17.895V21.5474H11.5498V17.5952H9.80957ZM12.4502 21.5474H14.4893V17.895C14.4893 17.731 14.3534 17.5952 14.1895 17.5952H12.4502V21.5474ZM18.8174 21.5474H22.3125C22.6242 21.5474 22.8748 21.2965 22.875 20.9849V12.1128C22.875 11.801 22.6243 11.5503 22.3125 11.5503H18.8174V21.5474Z",
                fill: "currentColor"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ forwardRef(SvgHotel);
const Memo = /*#__PURE__*/ memo(ForwardRef);
const Hotel = Memo;
export { Hotel as default };
